import { render, staticRenderFns } from "./CourseDescription.vue?vue&type=template&id=5e543808&scoped=true&"
import script from "./CourseDescription.vue?vue&type=script&lang=js&"
export * from "./CourseDescription.vue?vue&type=script&lang=js&"
import style0 from "./CourseDescription.vue?vue&type=style&index=0&id=5e543808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e543808",
  null
  
)

export default component.exports